import { render, staticRenderFns } from "./Auth0Wizard.vue?vue&type=template&id=1019c87c&"
import script from "./Auth0Wizard.vue?vue&type=script&lang=ts&"
export * from "./Auth0Wizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports